// assets
import { IconKey, Icon3dCubeSphere, IconClipboardList, IconBuildingWarehouse, IconClipboardPlus, IconShoppingCart } from '@tabler/icons';

// constant
const icons = { IconKey, Icon3dCubeSphere, IconClipboardList, IconBuildingWarehouse, IconClipboardPlus, IconShoppingCart };

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const services = {
    id: 'services',
    title: 'Pakalpojumi',
    type: 'group',
    children: [
        {
            id: 'agreements',
            title: 'Līgumi',
            type: 'item',
            url: '/agreements',
            icon: icons.IconClipboardList,
            breadcrumbs: false
        },
        {
            id: 'addresses',
            title: 'Adreses',
            type: 'item',
            url: '/addresses',
            icon: icons.IconBuildingWarehouse,
            breadcrumbs: false
        },
        {
            id: 'calendar',
            title: 'Kalendārs',
            type: 'item',
            url: '/calendar',
            icon: icons.Icon3dCubeSphere,
            breadcrumbs: false
        },
        {
            id: 'shop',
            title: 'Veikals',
            badge: 'Jaunums',
            type: 'item',
            url: '/shop',
            icon: icons.IconShoppingCart,
            breadcrumbs: false,
            shop: true
        }
    ]
};

export default services;
